/**
 * Compares the flags set in WordPress/cms and the flags connected to a product.
 * If there's a match it will return the color set to the flag in WP. Only first match will be returned.
 */

interface ProductFlags {
    code: string;
}

interface CmsData {
    flag: {
        code: string;
    };
    price_text_color: string;
}

export const getPriceColor = (cmsDataObjects: Array<CmsData>, productFlags: Array<ProductFlags>) => {
    if (!Array.isArray(cmsDataObjects)) {
        return "";
    }

    const priceColorObject = cmsDataObjects?.find(
        (cmsDataObject) => productFlags?.some((flag) => flag?.code === cmsDataObject?.flag?.code),
    );

    return priceColorObject?.price_text_color || "";
};
